import { forwardRef } from 'react';
import FocusLock from 'react-focus-lock';
import type { ReactFocusLockProps } from 'react-focus-lock/interfaces';

interface FocusTrapProps extends ReactFocusLockProps {
  group?: string;
}

export const FocusTrap = forwardRef<HTMLDivElement, FocusTrapProps>(({ children, disabled, group, ...props }, ref) => (
  <FocusLock ref={ref} group={group} {...props}>
    {children}
  </FocusLock>
));
